import { Chain } from '../interfaces/common'

export const getChainId = (chain: Chain) => {
  switch (chain) {
    case Chain.ARB:
      return 42161
    case Chain.BASE:
      return 8453
    case Chain.ETH:
      return 1
    default:
      return 0
  }
}
